'use client'

import { Box, Group, Text } from '@mantine/core'

import NextBaseImage from '@/components/basic/BaseImage'
import { CoinCategory } from '@/services/category'

import styles from '../styles.module.css'

export default function NameColumn({ category }: { category: CoinCategory }) {
  const { image_url, name } = category

  return (
    <Group gap={8} wrap="nowrap" miw={180} align="center">
      <Box className={styles.categoryImage}>
        <NextBaseImage src={image_url} width="100%" height="100%" radius="inherit" alt={name} />
      </Box>
      <Text
        variant="body1"
        style={{
          flex: 1,
          wordBreak: 'break-word',
          minWidth: 0,
        }}
      >
        {name}
      </Text>
    </Group>
  )
}
